import { render } from "./AirflowView.vue?vue&type=template&id=dfa13b74&scoped=true"
import script from "./AirflowView.vue?vue&type=script&lang=js"
export * from "./AirflowView.vue?vue&type=script&lang=js"

import "./AirflowView.vue?vue&type=style&index=0&id=dfa13b74&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfa13b74"]])

export default __exports__